module.exports = __webpack_public_path__ + "static/desktop/img/life-1.75cf3527.jpg";